var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"pr-1 flex-1"},[_vm._t("default")],2),_c('div',{staticClass:"description-long pl-1 small text-muted flex-1 mt-4 pt-1",domProps:{"innerHTML":_vm._s(_vm.descriptionLong)}})])}
var staticRenderFns = []

export { render, staticRenderFns }